export const SLIDER_CONFIG = {
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: true,
}

export const ANALYTICS_TYPES = {
  CURRENCY: 'currency',
  PERCENT: 'percent',
}

export const ARROW_COLORS = {
  UP_BLUE: '#2296F3',
  UP_GREEN: '#46de64',
  DOWN_RED: '#F05248',
}

export const CARD_DIMENSIONS = {
  IMAGE_HEIGHT: 325,
  // Marketplace cards size to content + footer actions; avoid percentage
  // heights that fight equal-height grid stretch and push CardActions out.
  CARD_HEIGHT_MARKETPLACE: 'auto',
  CARD_HEIGHT_DEFAULT: 'calc(100% - 330px)',
}

/**
 * MUI Grid size width formula (matches @mui/system gridGenerator).
 * Falls back when parent CSS vars are missing (e.g. wrapped cards).
 * Raw percentages ignore column gap and collapse 3-col layouts to 2.
 */
function gridItemWidth(size, columns = 12) {
  return `calc(100% * ${size} / var(--Grid-parent-columns, ${columns }) - (var(--Grid-parent-columns, ${columns }) - ${size }) * (var(--Grid-parent-columnSpacing, 0px) / var(--Grid-parent-columns, ${columns })))`
}

/**
 * Explicit Grid item widths for PropertyCard.
 * MUI Grid size calc depends on parent CSS vars that can be missing when
 * cards are wrapped (e.g. withSession / ErrorBoundary).
 */
export function getPropertyCardLayoutSx({ fullWidth = false, isPublic = false } = {}) {
  if (fullWidth) {
    return {
      width: { xs: '100%', md: '100%', xl: '100%' },
      maxWidth: { xs: '100%', md: '100%', xl: '100%' },
      flexBasis: 'auto',
      minWidth: 0,
    }
  }

  // Public + private desktop: 3 cols (size 4). Private tablet: 2 cols (size 6).
  const mdSize = isPublic ? 4 : 6
  const xlSize = 4
  const md = gridItemWidth(mdSize)
  const xl = gridItemWidth(xlSize)

  return {
    width: { xs: '100%', md, xl },
    maxWidth: { xs: '100%', md, xl },
    flexBasis: 'auto',
    minWidth: 0,
  }
}

export const AVATAR_POSITIONS = {
  HEART_LEFT: 5,
  HEART_TOP: 275,
  EXTERNAL_LEFT_OFFSET: 55,
  MARKETPLACE_LEFT: 5,
  MARKETPLACE_TOP: 275,
  RELIST_RIGHT: 50,
  RELIST_TOP: 280,
  MARKETPLACE_ICON_RIGHT: 5,
  MARKETPLACE_ICON_TOP: 275,
}

export const STRATEGIES = {
  BUILD_TO_RENT: 'Build to Rent',
  WHOLESALE: 'Wholesale',
  ASTROFLIP: 'Astroflip',
  BOR: 'BOR',
  SHORT_TERM_RENTAL: 'Short Term Rental',
  BRRRR: 'BRRRR',
  TURNKEY_END_BUYER: 'Turnkey End Buyer',
  FIX_AND_FLIP: 'Fix & Flip',
}

export const ORGANIZATION_MEMBERS = {
  PACEMORBY: 'pacemorby',
  ASTROFLIP: 'astroflip',
  PEP: 'pep',
}

export const IMAGE_SOURCES = {
  DEFAULT: '/images/default_image.png',
}
